angular.module("Crm.Transactions.Controller", ["transactionsService.Service", "programmesService.Service", "configsService.Service"]).controller("TransactionsCtrl", ["$rootScope", "NgTableParams", "Transactions", "$uibModal", "$scope", "Auth", "$state", "DocumentsProcedure", "VerifTemplates", function ($rootScope, NgTableParams, Transactions, $uibModal, $scope, Auth, $state, DocumentsProcedure, VerifTemplates) {
  var self = this;

  self.$onInit = function () {
    this.currentStateName = $state.current.name;

    if (self.hideColumn) {
      $rootScope.hideColumn = self.hideColumn;
    }

    self.hasRolesAdmin = Auth.hasRole("admin");
    const hideColumnLength = $rootScope.hideColumn ? Object.keys($rootScope.hideColumn).length : 0;
    this.nbTableTd = hideColumnLength > 0 ? 14 - hideColumnLength : 14;
  };

  self.listTransactions = new NgTableParams({}, {
    getData: params => {
      self.loading = true;
      const query = angular.copy(this.filtresTransactions);
      const filtreOrder = this.filtresTransactions && this.filtresTransactions.order ? this.filtresTransactions.order : "";
      const paramsOrder = params.sorting() ? params.sorting()[Object.keys(params.sorting())[0]] : "";
      query.limit = params.count();
      query.page = params.page();
      query.order = paramsOrder ? paramsOrder : filtreOrder;
      query.sort = params && params.sorting() && Object.keys(params.sorting())[0] ? Object.keys(params.sorting())[0] : this.filtresTransactions.sort; // clean

      for (var key in query) {
        if (query[key] === undefined || query[key].length === 0) {
          delete query[key];
        }
      }

      return Transactions.query(query).$promise.then(response => {
        params.total(response.total);
        self.totalTransactions = response.total;

        if (self.totalTransactions > 1) {
          self.labelTransactions = self.totalTransactions + " transactions trouvées";
        } else {
          self.labelTransactions = self.totalTransactions + " transaction trouvée";
        }

        angular.forEach(response.data, transaction => {
          if (!transaction.devise_unite) {
            transaction.devise_unite = "€";
            transaction.devise_code = "EUR";
          }

          if (transaction.type_id === 1) {
            transaction.timerArkaLabel = "Option échue dans";
          }

          if (transaction.type_id === 2 && transaction.signature_procedure_status === 50) {
            transaction.timerArkaLabel = "Purge SRU échue dans";
          }

          if (transaction.type_id === 2 && transaction.signature_procedure_status != 50) {
            transaction.timerArkaLabel = "Réservation échue dans";
          }

          if (transaction.purge_end_date && transaction.purge_end_date.date) {
            const now = moment();
            const purgeEndDate = moment(transaction.purge_end_date.date);
            const days = purgeEndDate.diff(now, "days");

            if (transaction.type_id > 2 && transaction.signature_procedure_status === 50 && days < 0) {
              transaction.label_signature = "Purge SRU échue";
            }
          }

          this.verifTemplates(transaction);
          this.getProcedure(transaction);
        });
        self.loading = false;
        return response.data;
      }).catch(function (err) {
        console.log("promise error", err);
      });
    }
  });

  this.verifTemplates = transaction => {
    VerifTemplates.get({
      programmeId: transaction.programme_id
    }).$promise.then(response => {
      transaction.isTemplateAvailable = response.template;
    });
  };

  this.getProcedure = transaction => {
    if (!transaction || !transaction.id || !transaction.contrat_reservation_id) {
      return;
    }

    DocumentsProcedure.get({
      transactionId: transaction.id,
      documentId: transaction.contrat_reservation_id
    }).$promise.then(response => {
      const membreProcedureId = "immodesk-membre-" + $rootScope.membreConnecter.id;

      if (response.validators) {
        const validators = response.validators; // TODO a delete après update de l'API membre

        transaction.myValidator = validators.find(v => v.reference === membreProcedureId);
      }

      const reservant = response.reservant; // TODO a delete après update de l'API membre

      transaction.myReservant = reservant && reservant.reference === membreProcedureId ? reservant : null;
    }).catch(error => {
      console.log(error);

      if (error.data && error.data.message) {
        $rootScope.$broadcast("toasterError", error.data.message);
      }
    });
  };

  $scope.$on("actualiserTransactions", event => {
    self.listTransactions.reload();
  });
  $scope.$watch(() => this.filtresTransactions, (val, old) => {
    angular.extend(self.listTransactions.filter(), val);
  }, true);
}]).controller("FiltreTransactionsCtrl", ["ConfigsVendeurs", "ConfigsPartenaires", "Programmes", function (ConfigsVendeurs, ConfigsPartenaires, Programmes) {
  this.$onInit = () => {
    this.datePickerStartDate = {
      formatYear: "yy",
      startingDay: 1,
      timezone: "Europe/Paris"
    };
    this.datePickerEndDate = {
      formatYear: "yy",
      startingDay: 1,
      timezone: "Europe/Paris"
    };
    ConfigsVendeurs.getVendeurs().then(result => {
      this.vendeurs = result.data;
    }).catch(err => {
      console.log("error :", err);
    });
    Programmes.get({
      limit: 99
    }).$promise.then(result => {
      this.programmes = result.data;
    }).catch(err => {
      console.log("error :", err);
    });
    this.getPartenaires();
  };

  this.getPartenaires = () => {
    ConfigsPartenaires.getPartenaires().then(response => {
      this.partenaires = response.data;
    }).catch(error => {
      console.log(error);
    });
  };
}]).controller("TransactionsTabCtrl", ["Transactions", "$scope", function (Transactions, $scope) {
  this.tabsData = [{
    heading: "En attente d'action de ma part",
    route: "transactionsTab.mesActionsEnAttente",
    badgeClass: "badge-danger",
    filtre: {
      etat: 4,
      type_id: 2,
      me: 1,
      signature_procedure_status: "null,-30,-20,0,2,10,20,30,40,45",
      order: "desc"
    },
    hideColumn: {}
  }, {
    heading: "Options Actives",
    route: "transactionsTab.optionsVentes",
    badgeClass: "badge-success",
    filtre: {
      etat: 4,
      type_id: 1,
      lot_statut: "1,2,5",
      order: "desc",
      slug_export: "options-actives"
    },
    hideColumn: {}
  }, {
    heading: "Options 48h",
    route: "transactionsTab.optionsEcheance",
    badgeClass: "badge-success",
    filtre: {
      etat: 4,
      type_id: 1,
      lot_statut: "1,2,5",
      order: "desc",
      echeance: true,
      slug_export: "options-echeance"
    },
    hideColumn: {}
  }, {
    heading: "Options Gelées",
    route: "transactionsTab.optionsGelees",
    badgeClass: "badge-success",
    filtre: {
      etat: 4,
      type_id: 1,
      lot_statut: "3,4,6",
      order: "desc",
      slug_export: "options-gelees"
    },
    hideColumn: {}
  }, {
    heading: "Options échues",
    route: "transactionsTab.echues",
    badgeClass: "badge-warning",
    filtre: {
      type_id: 1,
      etat: 2,
      order: "desc",
      slug_export: "options-echues"
    },
    hideColumn: {
      actions: true,
      transaction: true
    }
  }, {
    heading: "Réservé",
    route: "transactionsTab.validation",
    badgeClass: "badge-success",
    filtre: {
      etat: 4,
      type_id: 2,
      signature_procedure_status: "null,-30,-20,0,2,10,20,30,40,45",
      order: "desc",
      slug_export: "reserve"
    },
    hideColumn: {}
  }, {
    heading: "Purge SRU",
    route: "transactionsTab.sru",
    badgeClass: "badge-info",
    filtre: {
      etat: 4,
      type_id: 2,
      signature_procedure_status: 50,
      order: "desc",
      slug_export: "purge-sru"
    },
    hideColumn: {
      actions: true,
      transaction: false
    }
  }, {
    heading: "SRU Purgé",
    route: "transactionsTab.sru-end",
    badgeClass: "badge-info",
    filtre: {
      etat: 4,
      type_id: "2,5,6,7,8",
      signature_procedure_status: "52,65",
      order: "desc",
      slug_export: "transactions-purge-end"
    },
    hideColumn: {
      actions: true,
      transaction: false
    }
  }, {
    heading: "En attente de signature",
    route: "transactionsTab.enAttente",
    badgeClass: "badge-info",
    filtre: {
      etat: 4,
      type_id: "5,6,7,8",
      lot_statut: "3,6",
      signature_procedure_status: "null,0,10,20,30,40,45,50,52,60",
      order: "desc",
      slug_export: "en-attente-de-signature"
    },
    hideColumn: {
      actions: true,
      transaction: false
    }
  }, {
    heading: "Vendu",
    route: "transactionsTab.vendu",
    badgeClass: "badge-info",
    filtre: {
      etat: 4,
      type_id: 3,
      order: "desc",
      slug_export: "vendu"
    },
    hideColumn: {
      actions: true,
      transaction: false
    }
  }, {
    heading: "Transactions abandonnées",
    route: "transactionsTab.abandonnees",
    badgeClass: "badge-warning",
    filtre: {
      type_id: "1,2",
      etat: 1,
      order: "desc",
      slug_export: "transactions-abandonnees"
    },
    hideColumn: {
      actions: true,
      transaction: true
    }
  }];

  this.$onInit = () => {
    console.log("this.tabsData", this.tabsData);
    this.disabledProgramme = this.pid ? true : false;
    this.tabsData.forEach(data => {
      // Ajout du programme_id
      if (this.pid && data.filtre) {
        data.filtre.programme_id = this.pid;
      }
    });
    this.getTransactions();
  };

  this.getTransactions = () => {
    this.tabsData.forEach(data => {
      // Ajout de limit 1 pour badge
      const filtre = angular.copy(data.filtre);
      filtre.limit = 1;
      Transactions.query(filtre).$promise.then(response => {
        data.total = response.total;
      }).catch(error => {
        console.log("error", error);
      });
    });
  };

  $scope.$on("actualiserTransactions", event => {
    this.getTransactions();
  });
}]).controller("TransactionsAdvCtrl", ["NgTableParams", "Transactions", "$uibModal", "$scope", "$state", function (NgTableParams, Transactions, $uibModal, $scope, $state) {
  const filtreInitial = {
    etat: 4,
    type_id: "2,3,4,5,6,7,8",
    signature_procedure_status: "null,-20,0,2,10,20,30,35,40,45,50,52,55,60,65"
  };

  this.$onInit = () => {
    this.currentStateName = $state.current.name;
    this.filtre = filtreInitial;
    this.forAdv = true;
  };

  this.listTransactions = new NgTableParams({
    sorting: {
      date_last_update: "desc"
    }
  }, {
    getData: params => {
      this.loading = true;
      const query = angular.copy(this.filtre);
      query.limit = params.count();
      query.page = params.page();
      query.order = params.sorting() ? params.sorting()[Object.keys(params.sorting())[0]] : "";
      query.sort = params.sorting() ? Object.keys(params.sorting())[0] : ""; // clean

      for (var key in query) {
        if (query[key] === undefined || query[key].length === 0) {
          delete query[key];
        }
      }

      return Transactions.query(query).$promise.then(response => {
        params.total(response.total);
        this.totalTransactions = response.total;

        if (this.totalTransactions > 1) {
          this.labelTransactions = this.totalTransactions + " transactions trouvées";
        } else {
          this.labelTransactions = this.totalTransactions + " transaction trouvée";
        }

        angular.forEach(response.data, transaction => {
          if (!transaction.devise_unite) {
            transaction.devise_unite = "€";
            transaction.devise_code = "EUR";
          }

          transaction.client_statut_activation_message = "Aucun espace client activé";
          transaction.client_statut_activation_action = false;

          if (transaction.client_statut_activation == "DEMANDE_ACTIVATION") {
            transaction.client_statut_activation_message = "Renvoyer le lien d'activation de l'espace client";
            transaction.client_statut_activation_action = true;
          } else if (transaction.client_statut_activation == "ACTIVATION") {
            transaction.client_statut_activation_message = "Espace client actif";
            transaction.client_statut_activation_action = true;
          }
        });
        this.loading = false;
        return response.data;
      }).catch(function (err) {
        console.log("promise error", err);
      });
    }
  });

  this.openModalEspaceClient = transaction => {
    if (!transaction.client_statut_activation_action) {
      return;
    }

    const modalInstance = $uibModal.open({
      templateUrl: "src/espace-client/modal-renvoyer-espace-client.html",
      controller: "RenvoyerEspaceClientModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        contact: () => {
          return null;
        },
        transaction: () => {
          return transaction;
        }
      }
    });
    modalInstance.result.then(selectedItem => {
      self.selected = selectedItem;
    });
  };

  $scope.$watch(() => this.filtre, (val, old) => {
    angular.extend(this.listTransactions.filter(), val);
  }, true);
}]).controller("RenvoyerEspaceClientModalCtrl", ["$uibModalInstance", "contact", "transaction", "$state", "ContactActiverEspaceClient", "toaster", "$rootScope", "$scope", function ($uibModalInstance, contact, transaction, $state, ContactActiverEspaceClient, toaster, $rootScope, $scope) {
  this.$onInit = () => {
    $scope.contact = contact;
    $scope.transaction = transaction;
  };

  this.valider = () => {
    const contactActiverEspaceClient = new ContactActiverEspaceClient({
      contact_id: transaction.client_id,
      promoteur_id: $rootScope.commercialisateur.id,
      programme_id: transaction.programme_id,
      lot_id: transaction.lot_id
    });
    contactActiverEspaceClient.$save().then(response => {
      if (response.response.success === true) {
        $uibModalInstance.close();
        toaster.pop({
          type: "success",
          title: "",
          body: "L'envoi du lien d'activation a bien été pris en compte. Le client va recevoir un e-mail l'invitant à activer son espace personnel"
        });
        $state.reload();
      } else {
        toaster.pop({
          type: "error",
          title: "",
          body: "Une erreur s’est produite lors de l'envoi du lien de l'espace client de " + $ctrl.contact.nom + " " + $ctrl.contact.prenom
        });
      }
    }).catch(error => {
      console.log(error);
      toaster.pop({
        type: "error",
        title: "",
        body: error.message
      });
    });
  };

  this.annuler = () => {
    console.log("is close");
    $uibModalInstance.close();
  };
}]).filter("ucfirst", function () {
  return function (input) {
    return !!input ? input.charAt(0).toUpperCase() + input.substr(1) : "";
  };
});
angular.module("Crm.Transactions", ["Crm.Transactions.Controller", "Crm.TimerDirective", "Crm.AsDateDirective", "Crm.transactions.templates", "ngTable"]).component("transactions", {
  controller: "TransactionsCtrl",
  templateUrl: "src/transactions/transactions.html",
  bindings: {
    filtresTransactions: "<",
    labelTransactions: "=",
    mesActions: "<?",
    loading: "=",
    hideColumn: "<",
    vendeurSelected: "<",
    disabledProgramme: "<",
    totalTransactions: "=?"
  }
}).component("transactionsPurge", {
  controller: "TransactionsCtrl",
  templateUrl: "src/transactions/transactions-purge.html",
  bindings: {
    filtresTransactions: "<",
    labelTransactions: "=",
    mesActions: "<?",
    loading: "=",
    hideColumn: "<",
    vendeurSelected: "<",
    disabledProgramme: "<",
    totalTransactions: "=?"
  }
}).component("transactionsTab", {
  controller: "TransactionsTabCtrl",
  templateUrl: "src/transactions/transactions-tab.html",
  bindings: {
    pid: "<"
  }
}).component("transactionsAdv", {
  controller: "TransactionsAdvCtrl",
  templateUrl: "src/transactions/transactions-adv.html",
  bindings: {
    pid: "<"
  }
}).component("filtreTransactions", {
  controller: "FiltreTransactionsCtrl",
  templateUrl: "src/transactions/filtre-transactions.html",
  bindings: {
    filtre: "=",
    disabledProgramme: "<",
    forAdv: "<"
  }
});
/**
 * Module definition and dependencies
 */

angular.module("transactionsService.Service", ["ngResource"])
/**
 * Service
 */
.factory("Transactions", ["$resource", "Config", "$cacheFactory", function ($resource, Config, $cacheFactory) {
  var cache = $cacheFactory("transactionsCache");
  var interceptor = {
    response: function (response) {
      //cache.remove(response.config.url);
      cache.removeAll();
      return response;
    }
  };
  var transactionsApi = $resource(Config.API_BASE_URL + "/transactions/:id", {
    id: "@id"
  }, {
    query: {
      cache: cache,
      isArray: false,
      transformResponse: function (data) {
        let result = angular.fromJson(data);
        result.data = result.data.map(r => new transactionsApi(r));
        return result;
      }
    },
    update: {
      method: "PUT",
      interceptor: interceptor
    },
    queryExport: {
      isArray: false,
      method: "GET"
    },
    save: {
      method: "POST",
      interceptor: interceptor
    }
  });

  transactionsApi.prototype.createOrUpdate = function () {
    if (this.id) {
      return this.$update();
    } else {
      return this.$save();
    }
  };

  transactionsApi.prototype.removeCache = () => {
    cache.removeAll();
  };

  return transactionsApi;
}]).factory("TransactionsOptions", ["$http", "Config", function ($http, Config) {
  return {
    getTransactionsOptions: function (configParams) {
      return $http({
        method: "GET",
        url: Config.API_BASE_URL + "/transactions/?limit=1&type_id=1&etat=4",
        params: configParams
      });
    },
    getTransactionsPending: function (configParams) {
      return $http({
        method: "GET",
        url: Config.API_BASE_URL + "/transactions/?limit=1&type_id=2&etat=4&me=1",
        params: configParams
      });
    }
  };
}]).factory("TransactionsClient", ["$resource", "Config", function ($resource, Config) {
  var transactionApi = $resource(Config.API_BASE_URL + "/transactions/?client_id=:clientId", {
    clientId: "@clientId"
  }, {
    query: {
      isArray: false,
      transformResponse: function (data) {
        let result = angular.fromJson(data);
        result.data = result.data.map(r => new transactionApi(r));
        return result;
      }
    },
    update: {
      method: "PUT"
    }
  });
  return transactionApi;
}]).factory("TransactionsLot", ["$resource", "Config", function ($resource, Config) {
  var transactionApi = $resource(Config.API_BASE_URL + "/transactions/?lot_id=:lotId", {
    lotId: "@lotId"
  }, {
    query: {
      isArray: false
    }
  });
  return transactionApi;
}]).factory("HistoriqueTransactionDocument", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/transactions/:transactionId/documents/:documentId/activities", {
    transactionId: "@transactionId",
    documentId: "@documentId"
  }, {
    get: {
      isArray: true
    }
  });
  return api;
}]).factory("HistoriqueTransaction", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/transactions/:transactionId/historiques", {
    transactionId: "@transactionId"
  }, {
    get: {
      isArray: true
    }
  });
  return api;
}]).factory("AddNoteHistoriqueTransaction", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/transactions/:transactionId/ajouternotehistorique", {
    transactionId: "@transactionId"
  });
  return api;
}]).factory("TransactionUnlatch", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/transactions/:transactionId/signatureunlatch", {
    transactionId: "@transactionId"
  });
  return api;
}]).service("TransactionStatutService", function () {
  var transactionStatutId;
  return {
    getTransactionStatutId: function () {
      return transactionStatutId;
    },
    setTransationStatutId: function (value) {
      transactionStatutId = value;
    }
  };
});
angular.module('Crm.transactions.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('src/transactions/filtre-transactions.html','<form><div class="row"><div class="col-12 col-md-3 col-lg-2"><div class="form-group"> <label>Programme</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control" ng-model="$ctrl.filtre.programme_id" ng-disabled="$ctrl.disabledProgramme"><option value="">Programme</option><option ng-repeat="programme in $ctrl.programmes" value="{{programme.id}}"> {{programme.nom}}</option></select></div></div></div><div class="col-12 col-md-2 col-lg-1"><div class="form-group"> <label>Lot</label> <input type="text" class="form-control" ng-model="$ctrl.filtre.lot_nom"/></div></div><div ng-if="$parent.$ctrl.forAdv" class="col-12 col-md-2 col-lg-2"><div class="form-group"> <label>Nom du client</label> <input type="text" class="form-control" ng-model="$ctrl.filtre.client_search"/></div></div><div class="col-12 col-md-2 col-lg-2"><div class="form-group"> <label>Partenaire</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control" ng-model="$ctrl.filtre.partenaire_id"><option value="">Partenaire</option><option ng-repeat="partenaire in $ctrl.partenaires" value="{{partenaire.id}}">{{partenaire.nom | uppercase}}</option></select></div></div></div><div class="col-12 col-md-2 col-lg-2"><div class="form-group"> <label>Vendeur</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control" ng-model="$ctrl.filtre.vendeur_id"><option value="">Vendeur</option><option ng-repeat="vendeur in $ctrl.vendeurs" value="{{vendeur.id}}"> {{vendeur.nom}} {{vendeur.prenom}}</option></select></div></div></div><div ng-if="!$parent.$ctrl.forAdv" class="col-12 col-md-4 col-lg-3"><div class="row"><div class="col-12 col-md-6"><div class="form-group"> <label>Date de d\xE9but</label><div class="input-group input-group-date"> <input type="text" class="form-control" ng-model="$ctrl.filtre.start_date" as-date uib-datepicker-popup="dd/MM/yyyy" ng-click="openDatePickerStartDate = true" is-open="openDatePickerStartDate" datepicker-options="$ctrl.datePickerStartDate" show-button-bar="false" readonly/><span class="input-group-addon" ng-click="openDatePickerStartDate"><span class="glyphicon glyphicon-time"></span></span></div></div></div><div ng-if="!$parent.$ctrl.forAdv" class="col-12 col-md-6"><div class="form-group"> <label>Date de fin</label><div class="input-group input-group-date"> <input type="text" class="form-control" ng-model="$ctrl.filtre.end_date" as-date uib-datepicker-popup="dd/MM/yyyy" ng-click="openDatePickerEndDate = true" is-open="openDatePickerEndDate" datepicker-options="$ctrl.datePickerOptionsEndDate" show-button-bar="false" readonly/><span class="input-group-addon" ng-click="openDatePickerEndDate"><span class="glyphicon glyphicon-time"></span></span></div></div></div></div></div><div class="col-12 col-md-4 col-lg-2 col-lg-offset-0" ng-if="$ctrl.filtre.slug_export" style="margin-top: 25px; justify-content: end; display: flex;"><export-excel-transactions filters="$ctrl.filtre" label="Exporter la s\xE9lection"></export-excel-transactions></div></div></form>');
$templateCache.put('src/transactions/transactions-adv.html','<div class="container-fluid"><filtre-transactions filtre="$ctrl.filtre" loading="$ctrl.loading" for-adv="$ctrl.forAdv"></filtre-transactions><hr/><div class="no-border mt-1"><div class="flow-auto"><table ng-table="$ctrl.listTransactions" class="table table-striped table-bordered table-hover table-vmiddle table-mes-transactions table-responsive"><tr ng-repeat="item in $data" ng-if="!$ctrl.loading"><td class="strong" title="\'Programme\'" sortable="\'programme_nom\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.programme_nom }}</td><td title="\'Lot\'" sortable="\'lot_nom\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_nom }}</td><td title="\'Type\'" sortable="\'lot_type\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> <label class="label lotCouleur-{{ item.lot_type}}">{{ item.lot_type }}</label></td><td title="\'Prix TTC\'" sortable="\'prix\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.prix | currency : item.devise_unite: 0}}</td><td title="\'Client\'" sortable="\'client_nom\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.client_nom }}&nbsp;{{ item.client_prenom }}</td><td title="\'Vendeur\'" sortable="\'vendeur_nom\'" selection-model-ignore ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.vendeur_nom | uppercase }} {{ item.vendeur_prenom | ucfirst }}</td><td title="\'Statut\'" sortable="\'lot_statut\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.type_label }}</td><td title="\'Date de MaJ\'" sortable="\'date_last_update\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.date_last_update.date | moment: "DD/MM/YYYY" }}</td><td title="\'Esp. client\'" ng-click="$ctrl.openModalEspaceClient(item)" ng-disabled="!item.client_statut_activation_action"><span class="d-block text-center"><i class="fa fa-lock" tooltip-placement="top" uib-tooltip="{{ item.client_statut_activation_message }}"></i></span></td></tr><tr ng-if="$ctrl.listTransactions.data.length === 0 && !$ctrl.loading" class="text-center"><td colspan="8">Aucun r\xE9sultat.</td></tr><tr ng-if="$ctrl.loading" class="text-center"><td colspan="8"><div class="content_loader"><div class="loader_1">Loading...</div><span class="spacer--xs"></span></div></td></tr></table></div></div></div>');
$templateCache.put('src/transactions/transactions-purge-end.html','<div class="container-fluid"><filtre-transactions filtre="$ctrl.filtresTransactions" disabled-programme="$ctrl.disabledProgramme" loading="$ctrl.loading" ng-if="$root.env === \'immodesk\'"></filtre-transactions><hr/><div class="no-border mt-1"><div class="flow-auto"><table ng-table="$ctrl.listTransactions" class="table table-striped table-bordered table-hover table-vmiddle table-mes-transactions table-responsive"><tr ng-repeat="item in $data" ng-if="!$ctrl.loading"><td class="strong" title="\'Programme\'" sortable="\'programme_nom\'" ng-if="!$root.hideColumn.programme" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> **** {{ item.programme_nom }}</td><td title="\'Lot\'" sortable="\'lot_nom\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_nom }}</td><td title="\'\xC9tage\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_etage }}</td><td title="\'Type\'" sortable="\'lot_type\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> <label class="label lotCouleur-{{ item.lot_type}}">{{ item.lot_type }}</label></td><td title="\'Surface hab.\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_surface }}&nbsp;m\xB2</td><td title="\'Prix TTC\'" sortable="\'prix\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.prix | currency : item.devise_unite: 0}}</td><td title="\'Client\'" sortable="\'client_nom\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.client_nom }}&nbsp;{{ item.client_prenom }}</td><td title="\'Statut\'" sortable="\'lot_statut\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.type_label }}</td><td title="\'Statut signature\'" sortable="\'signature_procedure_status\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"><statut-signature statut="item.signature_procedure_status"></statut-signature></td><td title="\'Rang\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> <span>{{ item.rang }}</span></td><td title="\'Vendeur\'" selection-model-ignore ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.vendeur_nom | uppercase }} {{ item.vendeur_prenom | ucfirst }}</td><td title="\'Temps restant\'" sortable="\'purge_end_date\'" class="p-0" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"><div ng-if="item.type_id === 2 && item.etat === 4" timer-arka="{{item.purge_end_date.date}}" timer-arka-label="{{item.timerArkaLabel}}" class="timerArka"></div></td><td title="" ng-if="!$root.hideColumn.actions"><div class="row--sm"><div class="col-xs-12 col-md-12"><div ng-if="item.contrat_reservation_id !== 0 && item.type_id === 2" class="mb-1 text-center"> <span class="label alert-success">Contrat g\xE9n\xE9r\xE9</span></div><div ng-if="item.etat === 4"><div ng-if="!$ctrl.mesActions"><signature-btn ng-if="item.myValidator.status !== \'active\' && item.myReservant.status !== \'active\' " transaction="item" is-check-signature-requirements="true" is-notification-contrat-generer="true" add-class="\'mb-1\'"></signature-btn><btn-valider-contrat class="btn-content" transaction="item" my-validator="item.myValidator" my-reservant="item.myReservant"></btn-valider-contrat><btn-abandonner-valider-transaction ng-if="item.type_id === 1" btn-disabled="item.rang !== \'1\' || ($root.membreConnecter.is_partenaire && $root.configsCommercialisateurs.is_disabled_resa_for_comm)" transaction="item" transactions="$ctrl.transactions" title="\'R\xE9server\'" type-action="\'valider\'" add-class="\'btn btn-sm btn-block btn-primary\'"></btn-abandonner-valider-transaction><btn-abandonner-valider-transaction ng-if="item.etat == 4" transaction="item" transactions="$ctrl.transactions" title="\'Abandonner\'" type-action="\'abandonner\'" add-class="\'btn btn-sm btn-tertiary btn-block mt-1\'"></btn-abandonner-valider-transaction></div><div ng-if="$ctrl.mesActions"><btn-valider-contrat class="btn-content" transaction="item" my-validator="item.myValidator" my-reservant="item.myReservant"></btn-valider-contrat></div></div></div></div></td></tr><tr ng-if="$ctrl.listTransactions.data.length === 0 && !$ctrl.loading" class="text-center"><td colspan="{{ $ctrl.nbTableTd }}">Aucun r\xE9sultat.</td></tr><tr ng-if="$ctrl.loading" class="text-center"><td colspan="{{ $ctrl.nbTableTd }}"><div class="content_loader"><div class="loader_1">Loading...</div><span class="spacer--xs"></span></div></td></tr></table></div></div></div>');
$templateCache.put('src/transactions/transactions-purge.html','<div class="container-fluid"><filtre-transactions filtre="$ctrl.filtresTransactions" disabled-programme="$ctrl.disabledProgramme" loading="$ctrl.loading" ng-if="$root.env === \'immodesk\'"></filtre-transactions><hr/><div class="no-border mt-1"><div class="flow-auto"><table ng-table="$ctrl.listTransactions" class="table table-striped table-bordered table-hover table-vmiddle table-mes-transactions table-responsive"><tr ng-repeat="item in $data" ng-if="!$ctrl.loading"><td class="strong" title="\'Programme\'" sortable="\'programme_nom\'" ng-if="!$root.hideColumn.programme" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.programme_nom }}</td><td title="\'Lot\'" sortable="\'lot_nom\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_nom }}</td><td title="\'\xC9tage\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_etage }}</td><td title="\'Type\'" sortable="\'lot_type\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> <label class="label lotCouleur-{{ item.lot_type}}">{{ item.lot_type }}</label></td><td title="\'Surface hab.\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_surface }}&nbsp;m\xB2</td><td title="\'Prix TTC\'" sortable="\'prix\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.prix | currency : item.devise_unite: 0}}</td><td title="\'Client\'" sortable="\'client_nom\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.client_nom }}&nbsp;{{ item.client_prenom }}</td><td title="\'Statut\'" sortable="\'lot_statut\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.type_label }}</td><td title="\'Statut signature\'" sortable="\'signature_procedure_status\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"><statut-signature statut="item.signature_procedure_status"></statut-signature></td><td title="\'Rang\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> <span>{{ item.rang }}</span></td><td title="\'Vendeur\'" selection-model-ignore ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.vendeur_nom | uppercase }} {{ item.vendeur_prenom | ucfirst }}</td><td title="\'Temps restant\'" sortable="\'purge_end_date\'" class="p-0" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"><div ng-if="item.type_id === 2 && item.etat === 4" timer-arka="{{item.purge_end_date.date}}" timer-arka-label="{{item.timerArkaLabel}}" class="timerArka"></div></td><td title="" ng-if="!$root.hideColumn.actions"><div class="row--sm"><div class="col-xs-12 col-md-12"><div ng-if="item.contrat_reservation_id !== 0 && item.type_id === 2" class="mb-1 text-center"> <span class="label alert-success">Contrat g\xE9n\xE9r\xE9</span></div><div ng-if="item.etat === 4"><div ng-if="!$ctrl.mesActions"><signature-btn ng-if="item.myValidator.status !== \'active\' && item.myReservant.status !== \'active\' " transaction="item" is-check-signature-requirements="true" is-notification-contrat-generer="true" add-class="\'mb-1\'"></signature-btn><btn-valider-contrat class="btn-content" transaction="item" my-validator="item.myValidator" my-reservant="item.myReservant"></btn-valider-contrat><btn-abandonner-valider-transaction ng-if="item.type_id === 1" btn-disabled="item.rang !== \'1\' || ($root.membreConnecter.is_partenaire && $root.configsCommercialisateurs.is_disabled_resa_for_comm)" transaction="item" transactions="$ctrl.transactions" title="\'R\xE9server\'" type-action="\'valider\'" add-class="\'btn btn-sm btn-block btn-primary\'"></btn-abandonner-valider-transaction><btn-abandonner-valider-transaction ng-if="item.etat == 4" transaction="item" transactions="$ctrl.transactions" title="\'Abandonner\'" type-action="\'abandonner\'" add-class="\'btn btn-sm btn-tertiary btn-block mt-1\'"></btn-abandonner-valider-transaction></div><div ng-if="$ctrl.mesActions"><btn-valider-contrat class="btn-content" transaction="item" my-validator="item.myValidator" my-reservant="item.myReservant"></btn-valider-contrat></div></div></div></div></td></tr><tr ng-if="$ctrl.listTransactions.data.length === 0 && !$ctrl.loading" class="text-center"><td colspan="{{ $ctrl.nbTableTd }}">Aucun r\xE9sultat.</td></tr><tr ng-if="$ctrl.loading" class="text-center"><td colspan="{{ $ctrl.nbTableTd }}"><div class="content_loader"><div class="loader_1">Loading...</div><span class="spacer--xs"></span></div></td></tr></table></div></div></div>');
$templateCache.put('src/transactions/transactions-tab.html','<div class="tab-container" type="tabs"><div class="mt-1 mb-1"><export-excel-transactions label="Tout exporter"></export-excel-transactions></div><ul class="nav nav-tabs"><li ng-repeat="tab in $ctrl.tabsData" class="tab uib-tab nav-item" ui-sref="{{tab.route}}" ui-sref-active="active"> <a class="nav-link">{{tab.heading}} <span class="badge {{ tab.badgeClass }}">{{ tab.total }}</span></a></li></ul><div class="tab-content"><div class="tab-pane active"><ui-view></ui-view></div></div></div>');
$templateCache.put('src/transactions/transactions.html','<div class="container-fluid"><filtre-transactions filtre="$ctrl.filtresTransactions" disabled-programme="$ctrl.disabledProgramme" loading="$ctrl.loading" ng-if="$root.env === \'immodesk\'"></filtre-transactions><hr/><div class="no-border mt-1"><div><table ng-table="$ctrl.listTransactions" class="table table-striped table-bordered table-hover table-vmiddle table-mes-transactions table-responsive"><tr ng-repeat="item in $data" ng-if="!$ctrl.loading"><td title="\'Client\'" sortable="\'client_nom\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.client_nom }}&nbsp;{{ item.client_prenom }}</td><td class="strong" title="\'Programme\'" sortable="\'programme_nom\'" ng-if="!$root.hideColumn.programme" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.programme_nom }}</td><td title="\'Lot\'" sortable="\'lot_nom\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_nom }}</td><td title="\'Statut\'" sortable="\'lot_statut\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.type_label }}</td><td title="\'Rang\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> <span>{{ item.rang }}</span></td><td title="\'Temps restant\'" sortable="\'date_validite\'" class="p-0" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"><div ng-if="item.type_id !== 2 && item.etat !== 1" timer-arka="{{item.date_validite.date}}" timer-arka-label="{{item.timerArkaLabel}}" class="timerArka"></div><div ng-if="item.etat === 1" class="text-center"> <label class="label label-danger">Abandonn\xE9e</label></div></td><td title="\'Statut signature\'" sortable="\'signature_procedure_status\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"><div ng-if="item.label_signature">{{ item.label_signature }}</div><statut-signature ng-if="!item.label_signature" statut="item.signature_procedure_status"></statut-signature></td><td title="\'Type\'" sortable="\'lot_type\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> <label class="label lotCouleur-{{ item.lot_type}}">{{ item.lot_type }}</label></td><td title="\'\xC9tage\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_etage }}</td><td title="\'Surface hab.\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.lot_surface }}&nbsp;m\xB2</td><td title="\'Prix TTC\'" sortable="\'prix\'" ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.prix | currency : item.devise_unite: 0}}</td><td title="\'Vendeur\'" selection-model-ignore ui-sref="transaction.transactionhistorique({id:item.id, paramsFiltresTransactions: $ctrl.filtresTransactions, stateSource: $ctrl.currentStateName})"> {{ item.vendeur_nom | uppercase }} {{ item.vendeur_prenom | ucfirst }}</td><td title="" ng-if="!$root.hideColumn.actions"><div class="row--sm"><div class="col-xs-12 col-md-12"><div ng-if="item.contrat_reservation_id !== 0 && item.type_id === 2" class="mb-1 text-center"> <span class="label alert-success">Contrat g\xE9n\xE9r\xE9</span></div><div ng-if="item.etat === 4 && item.type_id != 3"><div ng-if="!$ctrl.mesActions"><signature-btn ng-if="item.myValidator.status !== \'active\' && item.myReservant.status !== \'active\' " transaction="item" is-check-signature-requirements="true" is-notification-contrat-generer="true" add-class="\'mb-1\'"></signature-btn><btn-valider-contrat class="btn-content" transaction="item" my-validator="item.myValidator" my-reservant="item.myReservant"></btn-valider-contrat><btn-abandonner-valider-transaction ng-if="item.type_id === 1" btn-disabled="item.rang !== \'1\' || ($root.membreConnecter.is_partenaire && $root.configsCommercialisateurs.is_disabled_resa_for_comm)" transaction="item" transactions="$ctrl.transactions" title="\'R\xE9server\'" type-action="\'valider\'" add-class="\'btn btn-sm btn-block btn-primary\'"></btn-abandonner-valider-transaction><btn-abandonner-valider-transaction ng-if="item.etat == 4" transaction="item" transactions="$ctrl.transactions" title="\'Abandonner\'" type-action="\'abandonner\'" add-class="\'btn btn-sm btn-tertiary btn-block mt-1\'"></btn-abandonner-valider-transaction></div><div ng-if="$ctrl.mesActions"><btn-valider-contrat class="btn-content" transaction="item" my-validator="item.myValidator" my-reservant="item.myReservant"></btn-valider-contrat></div></div></div></div></td></tr><tr ng-if="$ctrl.listTransactions.data.length === 0 && !$ctrl.loading" class="text-center"><td colspan="{{ $ctrl.nbTableTd }}">Aucun r\xE9sultat.</td></tr><tr ng-if="$ctrl.loading" class="text-center"><td colspan="{{ $ctrl.nbTableTd }}"><div class="content_loader"><div class="loader_1">Loading...</div><span class="spacer--xs"></span></div></td></tr></table></div></div></div>');
$templateCache.put('src/transactions/tabs/abandonnees.html','<transactions filtres-transactions="$parent.$ctrl.tabsData[10].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[10].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions>');
$templateCache.put('src/transactions/tabs/echues.html','<transactions filtres-transactions="$parent.$ctrl.tabsData[4].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[4].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions>');
$templateCache.put('src/transactions/tabs/en-attente.html','<transactions filtres-transactions="$parent.$ctrl.tabsData[8].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[8].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions>');
$templateCache.put('src/transactions/tabs/options-echeance.html','<transactions filtres-transactions="$parent.$ctrl.tabsData[2].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[2].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions>');
$templateCache.put('src/transactions/tabs/options-gelees.html','<transactions filtres-transactions="$parent.$ctrl.tabsData[3].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[3].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions>');
$templateCache.put('src/transactions/tabs/options-ventes.html','<transactions filtres-transactions="$parent.$ctrl.tabsData[1].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[1].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions>');
$templateCache.put('src/transactions/tabs/sru-end.html','<transactions-purge filtres-transactions="$parent.$ctrl.tabsData[7].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[7].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions-purge>');
$templateCache.put('src/transactions/tabs/sru.html','<transactions-purge filtres-transactions="$parent.$ctrl.tabsData[6].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[6].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions-purge>');
$templateCache.put('src/transactions/tabs/transactions-en-attente.html','<transactions filtres-transactions="$parent.$ctrl.tabsData[0].filtre" label-transactions="labelTransactions" mes-actions="true" loading="loading" hide-column="$parent.$ctrl.tabsData[0].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions>');
$templateCache.put('src/transactions/tabs/validation.html','<transactions filtres-transactions="$parent.$ctrl.tabsData[5].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[5].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions>');
$templateCache.put('src/transactions/tabs/vendu.html','<transactions filtres-transactions="$parent.$ctrl.tabsData[9].filtre" label-transactions="labelTransactions" loading="loading" hide-column="$parent.$ctrl.tabsData[9].hideColumn" vendeur-selected="vendeurSelected" disabled-programme="$ctrl.disabledProgramme"></transactions>');}]);